import React, { useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import Icon from '../AppIcon';

const ClientDashboardTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { companyIdentifier } = useParams();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const tabs = [
    {
      path: `/client/${companyIdentifier}`,
      basePath: 'client-dashboard-home',
      label: 'Dashboard',
      icon: 'LayoutDashboard',
      description: 'Overview and analytics'
    },
    {
      path: `/client/${companyIdentifier}/profile`,
      basePath: 'company-profile-management',
      label: 'Profile',
      icon: 'Building2',
      description: 'Company information'
    },
    {
      path: `/client/${companyIdentifier}/floor-types`,
      basePath: 'floor-types-pricing',
      label: 'Floor Types',
      icon: 'Grid3x3',
      description: 'Products and pricing'
    },
    {
      path: `/client/${companyIdentifier}/colors`,
      basePath: 'colors-management',
      label: 'Colors',
      icon: 'Palette',
      description: 'Color swatches'
    },
    {
      path: `/client/${companyIdentifier}/rooms`,
      basePath: 'rooms-management',
      label: 'Rooms',
      icon: 'Home',
      description: 'Room templates'
    },
    {
      path: `/client/${companyIdentifier}/gallery`,
      basePath: 'gallery-projects',
      label: 'Gallery',
      icon: 'Image',
      description: 'Project showcase'
    },
    {
      path: `/client/${companyIdentifier}/embed`,
      basePath: 'embed-links-management',
      label: 'Embed Links',
      icon: 'Code',
      description: 'Integration codes'
    }
  ];

  // Check if current path matches any tab (with or without company identifier)
  const isActiveTab = (tab) => {
    const currentPath = location?.pathname;
    // Match exact path or base path for active state
    return currentPath === tab?.path || currentPath?.includes(tab?.basePath);
  };

  const handleTabClick = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  return (
    <>
      <div className="lg:hidden fixed top-4 right-4 z-[1100]">
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="w-10 h-10 bg-surface border border-border rounded-lg flex items-center justify-center shadow-md"
          aria-label="Toggle menu"
        >
          <Icon name={mobileMenuOpen ? 'X' : 'Menu'} size={20} />
        </button>
      </div>
      {mobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-background/80 backdrop-blur-sm z-[1050]"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}
      <nav
        className={`
          client-dashboard-tabs
          lg:block
          ${mobileMenuOpen ? 'fixed top-0 left-0 right-0 bottom-0 z-[1100] overflow-y-auto' : 'hidden'}
        `}
      >
        <div className="lg:hidden p-6 border-b border-border">
          <h2 className="text-lg font-semibold text-text-primary">Navigation</h2>
        </div>

        <div className="client-dashboard-tabs-list lg:flex-row flex-col">
          {tabs?.map((tab) => (
            <button
              key={tab?.path}
              onClick={() => handleTabClick(tab?.path)}
              className={`
                client-dashboard-tab
                lg:flex-row flex-col lg:items-center items-start
                lg:gap-2 gap-1
                lg:px-4 px-6
                lg:py-3 py-4
                lg:border-b-2 border-b-0 lg:border-l-0 border-l-4
                ${isActiveTab(tab) ? 'client-dashboard-tab-active' : ''}
              `}
            >
              <Icon name={tab?.icon} size={18} />
              <div className="lg:hidden flex flex-col items-start">
                <span className="font-medium">{tab?.label}</span>
                <span className="text-xs text-text-secondary">{tab?.description}</span>
              </div>
              <span className="hidden lg:inline">{tab?.label}</span>
            </button>
          ))}
        </div>
      </nav>
    </>
  );
};

export default ClientDashboardTabs;